import { QueryClient } from '@tanstack/react-query';

import { OperationDetails } from '~/routes/production_planning_pages/operations/types';
import { supabase } from '~/utils/supabaseClient';

export const operationDetailsQuery = (id: string) => ({
  queryKey: ['product', 'detail', id],
  queryFn: async () => {
    const request = supabase
      .from('operation_versions')
      .select(
        `
        *,
        profiles(
          profile_first_name,
          profile_last_name
        ),
        bill_of_operations_versions(*),
        operations(
          is_archived,
          checks_revision,
          operations_stations(
            factory_name,
            zone_name,
            station_name
          )
        )
      `,
      )
      .is('bill_of_operations_versions.is_current_version', true)
      .is('is_current_version', true)
      .eq('operation_id', id)
      .maybeSingle();

    const { data, error } = await request;

    if (!data || error) {
      throw new Response('', {
        status: 404,
        statusText: 'Not Found',
      });
    }

    return {
      ...data,
      operations: {
        ...data.operations,
        operations_stations: data.operations?.operations_stations ?? [],
        is_final: data?.is_final ?? false,
      },
      is_batch_processing_enabled: false,
      operation_is_archived: data.operations?.is_archived ?? false,
      is_final: data?.is_final ?? false,
    } as OperationDetails;
  },
});

export const getOperationTags = (partnerName: string) => ({
  queryKey: ['operation_tags'],
  queryFn: async () => {
    const request = supabase.from('operation_tags').select('*').eq('partner_name', partnerName);

    const { data } = await request;

    if (!data) {
      throw new Response('', {
        status: 404,
        statusText: 'Not Found',
      });
    }
    return data;
  },
});

export const loader =
  (queryClient: QueryClient) =>
  async ({ params }: any) => {
    const query = operationDetailsQuery(params.operationId);
    return queryClient.getQueryData(query as any) ?? (await queryClient.fetchQuery(query));
  };
